<script>
    import { mapActions, mapState } from 'vuex';
    import bemMixin from '@dreipol/vue-ui/src/mixins/bem';
    import isDesktopMixin from 'framework/mixins/is-desktop';

    export default {
        mixins: [bemMixin('mobile-menu'), isDesktopMixin],
        computed: {
            ...mapState('header-search', {
                isHeaderSearchVisible: 'isVisible',
            }),
            rootClasses() {
                return [
                    this.bemIf(this.isHeaderSearchVisible, 'no-shadow'),
                ];
            },
        },
        methods: {
            ...mapActions('header-search', {
                toggleHeaderSearch: 'toggle',
            }),
        },
    };
</script>
